import { IconDownload, IconTrash, IconCircleCheck } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";
import { IconPill } from "../../../../components/common/icon-pill";

interface Props {
  file: File;
  compact?: boolean;
  onRemove: () => void;
}

export function UploadedFileCard({ file, compact = false, onRemove }: Props) {
  const containerClass = compact
    ? "flex items-center gap-4 rounded-xl border border-borderDefault bg-bgLight px-4 py-3"
    : "flex items-center gap-4 rounded-2xl border border-borderDefault bg-bgWhite px-6 py-4 shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)]";

  return (
    <div className={containerClass}>
      <IconCircleCheck size={57} className="shrink-0 text-accentGreen" />
      <div className="flex flex-1 flex-col gap-0.5 min-w-0">
        <Text variant="bodyBold" tone="dark">Products file</Text>
        <Text variant="bodySm" tone="muted">{file.name}</Text>
        <Text variant="bodySm" tone="muted">{(file.size / (1024 * 1024)).toFixed(1)} MB</Text>
      </div>
      <div className="flex items-center gap-6 shrink-0 pr-3">
        <IconPill as="button" size={36} tone="ghost" aria-label="Download file" className="!bg-transparent !text-textMuted hover:!text-textDark">
          <IconDownload size={31} />
        </IconPill>
        <IconPill as="button" size={36} tone="ghost" aria-label="Remove file" onClick={onRemove} className="!bg-transparent !text-textMuted hover:!text-textDark">
          <IconTrash size={31} />
        </IconPill>
      </div>
    </div>
  );
}
